import React from 'react';
import { Link } from 'react-router-dom';
import { Music, ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { ADDON_PRICES } from '../utils/orderPricing';

export const PersonalisedSongPromo = ({ testId = 'song-promo' }) => (
  <section className="py-20 bg-black" data-testid={testId}>
    <div className="container mx-auto px-4 lg:px-8">
      <Reveal className="relative overflow-hidden max-w-5xl mx-auto rounded-3xl border border-amber-500/20 bg-gradient-to-r from-black via-amber-500/[0.06] to-black p-8 md:p-12">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />
        <div className="grid md:grid-cols-[1fr,auto] gap-8 items-center">
          <div className="flex items-start gap-5">
            <div className="w-14 h-14 rounded-full border border-amber-500/40 bg-black flex items-center justify-center flex-shrink-0">
              <Music size={22} className="text-amber-400" strokeWidth={1.5} />
            </div>
            <div className="space-y-3">
              <p className="uppercase tracking-[0.3em] text-xs text-amber-400">Optional Upgrade · <span className="whitespace-nowrap">+£{ADDON_PRICES.song}</span></p>
              <h2 className="text-3xl md:text-4xl font-bold text-white font-editorial leading-tight">
                Your Story, <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">Your Song</span>
              </h2>
              <p className="text-gray-300 leading-relaxed max-w-xl">
                Add an original personalised song to any cinematic presentation, inspired by your special occasion, personal memories and the people who matter most.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-3">
            <Link to="/pricing?song=1" data-testid={`${testId}-order-link`}
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold bg-gradient-to-r from-amber-500 to-amber-600 text-black hover:from-amber-600 hover:to-amber-700 transition-transform duration-300 hover:scale-105">
              Add to My Order <ArrowRight size={16} />
            </Link>
            <Link to="/pricing" data-testid={`${testId}-pricing-link`}
              className="inline-flex items-center justify-center px-7 py-3.5 rounded-full border border-white/20 text-white/90 font-medium hover:border-amber-500/60 hover:text-amber-300 transition-colors">
              View Pricing
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default PersonalisedSongPromo;
